// eslint-disable-next-line import/no-named-as-default
import Alpine from 'alpinejs'

Alpine.data('pagination', (content: any) => ({
  displayedContent: [] as any,
  currentPage: 0,
  itemsPerPage: 10,
  observer: null as IntersectionObserver | null,

  init() {
    this.displayedContent = []
    this.createObserver()
  },

  destroy() {
    this.observer && this.observer.disconnect()
  },

  createObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    }

    const observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      options,
    )
    const target = document.querySelector('.observerIdentifier')
    observer.observe(target!)

    this.observer = observer as any
  },

  handleIntersect(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.showNext()
      }
    })
  },

  showNext() {
    const startIndex = this.currentPage * this.itemsPerPage
    const endIndex = startIndex + this.itemsPerPage
    this.displayedContent = [
      ...(this.displayedContent as any),
      ...content.slice(startIndex, endIndex),
    ]
    this.currentPage++
  },
}))
